<div class="json-container">
    <ul>
      <li *ngFor="let key of getKeys(jsonData)">
        <span class="json-key">{{ key }}</span>: 
        
        <!-- 數值 -->
        <span *ngIf="isNumber(jsonData[key])" class="json-number">{{ jsonData[key] }}</span>
  
        <!-- 字串 -->
        <span *ngIf="isString(jsonData[key])" class="json-string">"{{ jsonData[key] }}"</span>
  
        <!-- Boolean -->
        <span *ngIf="isBoolean(jsonData[key])" class="json-boolean">{{ jsonData[key] }}</span>
  
        <!-- Null -->
        <span *ngIf="isNull(jsonData[key])" class="json-null">null</span>
  
        <!-- 物件遞迴顯示 -->
        <app-json-viewer *ngIf="isObject(jsonData[key])" [jsonData]="jsonData[key][0]"></app-json-viewer>
  
        <!-- 陣列 -->
        <ul *ngIf="isArray(jsonData[key])">
          <li *ngFor="let item of jsonData[key]">
            <app-json-viewer *ngIf="isObject(item)" [jsonData]="item"></app-json-viewer>
            <span *ngIf="isString(item)" class="json-string">"{{ item }}"</span>
            <span *ngIf="isNumber(item)" class="json-number">{{ item }}</span>
            <span *ngIf="isBoolean(item)" class="json-boolean">{{ item }}</span>
            <span *ngIf="isNull(item)" class="json-null">null</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
  